'use client';

import { usePathname } from 'next/navigation';

import { useHeaderCurrentUserFacade } from '../hooks/use-header-current-user.facade';
import { HeaderSkeleton } from './components/header-skeleton.component';
import { IncompleteProfileContentContainer } from './incomplete-profile-content/incomplete-profile-content.container';
import { MainContentContainer } from './main-content/main-content.container';

type Props = {
  isShowMobileNavigation?: boolean;
};

export const PrivateContentContainer = ({ isShowMobileNavigation }: Props) => {
  const { hasInputRequiredProfile, loading } = useHeaderCurrentUserFacade();
  const pathname = usePathname() ?? '';

  // GitHubアカウントで登録した場合のみ、直近の経験の入力完了でhasInputRequiredProfileがtrueになり
  // 入力ステップを複数残した段階でログイン後ヘッダーが表示されてしまい、途中で入力を中断してしまう可能性がある
  // 他サービスでのアカウント登録時においては新規登録中にヘッダーの表示は切り替わらないためそちらに合わせる
  const isCompletedProfileContentContainer =
    hasInputRequiredProfile && !pathname.startsWith('/steps/profile');

  return loading ? (
    <HeaderSkeleton />
  ) : isCompletedProfileContentContainer ? (
    <MainContentContainer isShowMobileNavigation={isShowMobileNavigation} />
  ) : (
    <IncompleteProfileContentContainer />
  );
};
